import React from 'react'
import LockIcon from "@mui/icons-material/Lock";
import "./lockscreen.css";

const InviteExpired = () => {
  return (
     <div className="lock-screen-container">
      <section className="lock-screen-card" role="status" aria-live="polite">
        <div className="hero">
          <img src="/envelope.png" alt="" className="lock-screen-envelope" />

          {/* pulsing ring behind the lock area */}
          <span className="lock-pulse" aria-hidden="true" />

          {/* tiny floating petals/confetti */}
          <span className="confetti c1" />
          <span className="confetti c2" />
          <span className="confetti c3" />
          <span className="confetti c4" />
          <span className="confetti c5" />
        </div>

        <h1 className="title">This Invite Has Expired</h1>
        <p className="subtitle">
         This wedding invite is no longer active<br />
        </p>

        <div className="status-pill" aria-hidden="true">
          <LockIcon className="pill-icon" />
         Invite Expired
        </div>
      </section>
    </div>
  )
}

export default InviteExpired